exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.fullscreen[data-v-2d61bc50]{\n  width: 100%;\n  height: 100vh;\n}\n", ""]);

// exports
